import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, verifyUserToken } from '../features/auth/authSlice';
import { loadEffectivePlatformPermissions } from '../features/platformPermissions/platformPermissionsSlice';
import { loadOrganizationStandards } from '../features/organizationStandards/organizationStandardsSlice';
import type { RootState } from '../store/store';
import { useAppDispatch } from '../store/hooks';

interface AuthInitializerProps {
  children: React.ReactNode;
}

/**
 * Background token health-check.
 * Navigation guarding is handled by RequireAuth at the route level.
 */
export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector((state: RootState) => selectIsAuthenticated(state));
  const token = useSelector((state: RootState) => state.auth.token);

  useEffect(() => {
    if (isAuthenticated && token) {
      dispatch(verifyUserToken());
      dispatch(loadEffectivePlatformPermissions());
      dispatch(loadOrganizationStandards());
    }
  }, [isAuthenticated, token, dispatch]);

  return <>{children}</>;
};
